import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import {
  migrationService,
  type MigrationJobStatus,
  type MigrationJobsListParams,
} from '../api/migration.service';

const IN_PROGRESS: MigrationJobStatus[] = ['pending', 'fetching', 'syncing'];

export function useMigrationJobsQuery(params: MigrationJobsListParams = {}) {
  return useQuery({
    queryKey: queryKeys.migration.jobs(params),
    queryFn: () => migrationService.listJobs(params),
    refetchInterval: (query) => {
      const jobs = query.state.data ?? [];
      const hasActive = jobs.some((j) => IN_PROGRESS.includes(j.status));
      return hasActive ? 5_000 : 30_000;
    },
  });
}
